<template>
<div class="move">
	<van-nav-bar :title="this.videoInfo.vod_name" >
	  <template #left>
	    <van-icon name="arrow-left" color="#fff" @click="back()"/>
	  </template>
	</van-nav-bar>
	
	<!-- <Mydplayer :url="nowPlayVideoUrl" :pic='cover' /> -->
	
	<div class="movie-video">
	  <d-player v-if="videoUrl" ref="player" id="player" @play="handlePlay" @pause="handlePause" :options="options"></d-player>
	  <div v-else class="video-loading">
	    <van-loading type="spinner" color="#1989fa">{{$t('video.loading') || '読み込み中...'}}</van-loading>
	  </div>
	</div>
	
	<div class="title">
		<p>
			{{ this.videoInfo.vod_name}}
		</p>
		<span>
			{{this.videoInfo.count}}{{$t('video.bofangliang')}}
		</span>
	</div>
	<div class="item">
		<div class="title">
			<span>
				<i>
					<img src="data:image/png;base64,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"
					alt="">
				</i>
				{{$t('video.hotlist')}}
			</span>
		</div>		
		<div class="van-pull-refresh">
			<div class="van-pull-refresh__track" style="transition-duration: 0ms;">
				<div class="van-pull-refresh__head"></div>
				<div role="feed" class="van-list" aria-busy="true">
					<ul class="hot">
						<li  @click="toPlayVideo(v.id)" v-for="(v,key) in moreVideoInfo" :key="key">
							<img :src="v.vod_pic" alt="">
							<div>
								<span>
									{{ v.vod_name }}
								</span>
								<span>
									{{$t('video.bofangliang')}}:{{ v.count }}
								</span>
							</div>
						</li>						
					</ul>					
					<div class="van-list__placeholder"></div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
// import Mydplayer from '../../common/Mydplayer'
// import DPlayer from "dplayer";

export default {
	// components: {
	//   Mydplayer
	// },
  data() {
    return {
      nowPlayVideoUrl: "",
      cover:"",
      userInfo:[],
      videoInfo:{},
      moreVideoInfo:{},
      player:null,
      videoUrl: '', // 视频 URL
      videoPic: '', // 视频封面
      eventListenersBound: false // 标志位，确保事件只绑定一次
    };
  },
  computed: {
    // 使用 computed 动态生成 options，确保视频 URL 变化时播放器能正确更新
    options() {
      // 检测视频类型
      let videoType = 'auto'; // 默认自动检测
      if(this.videoUrl){
        if(this.videoUrl.includes('.m3u8') || this.videoUrl.includes('.m3u')){
          videoType = 'hls';
        } else if(this.videoUrl.includes('.flv')){
          videoType = 'flv';
        } else if(this.videoUrl.includes('.mp4') || this.videoUrl.includes('.webm')){
          videoType = 'normal';
        }
      }
      
      return {
	    mutex: false, //  防止同时播放多个用户，在该用户开始播放时暂停其他用户
	    theme: "#b7daff", // 风格颜色，例如播放条，音量条的颜色
	    loop: false, // 是否自动循环
        autoplay: false,
        lang: "ja", // 语言，'en', 'zh-cn', 'zh-tw', 'ja' (日语)
	    screenshot: true, // 是否允许截图（按钮），点击可以自动将截图下载到本地
	    hotkey: true, // 是否支持热键，调节音量，播放，暂停等
	    preload: "auto", // 自动预加载
	    volume: 0.7, // 初始化音量
	    playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3], //可选的播放速度，可自定义
        logo: "", // 在视频左上角上打一个logo
	    video: {
          url: this.videoUrl, // 播放视频的路径
          pic: this.videoPic || undefined, // 如果 videoPic 为空，不设置 pic，避免 CORS 错误
          thumbnails: "", // 进度条上的缩略图
          type: videoType // 视频类型：'auto', 'hls', 'flv', 'normal'
	    },
      };
    }
  },
  methods: {
    back(){
      this.$router.push({path:'Home'})
    },
    getVideoInfo(){
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'video_get_info'
      }).then(res=>{
        if(res.code === 200 && res.data){
        this.videoInfo = res.data;
          this.nowPlayVideoUrl = this.videoInfo.vod_play_url || '';
          
          // 确保视频 URL 有效
          if(this.videoInfo.vod_play_url){
            console.log('视频信息:', {
              url: this.videoInfo.vod_play_url,
              pic: this.videoInfo.vod_pic,
              type: this.videoInfo.vod_play_url.includes('.m3u8') ? 'hls' : 'normal'
            });
            
            // 更新视频 URL
            this.videoUrl = this.videoInfo.vod_play_url;
            
            // 定义更新播放器的函数
            const updatePlayer = () => {
              // 使用 $nextTick 确保 DOM 更新后再操作
              this.$nextTick(() => {
                // 等待播放器完全初始化
                setTimeout(() => {
                  // 如果播放器实例存在，更新视频源
                  if(this.$refs.player && this.$refs.player.dp){
                    try {
                      console.log('更新播放器视频源:', this.videoUrl);
                      
                      // 使用 switchVideo 方法更新视频，只在 videoPic 有值时设置 pic
                      const videoConfig = {
                        url: this.videoUrl,
                        type: this.getVideoType(this.videoUrl)
                      };
                      if(this.videoPic){
                        videoConfig.pic = this.videoPic;
                        // 安全地设置背景图片
                        const bezel = document.querySelector(".dplayer-bezel");
                        if(bezel){
                          bezel.style.backgroundImage = 'url("'+this.videoPic+'")';
                          bezel.style.backgroundRepeat = 'no-repeat';
                          bezel.style.backgroundSize = 'cover';
                        }
                      }
                      this.$refs.player.dp.switchVideo(videoConfig);
                    
                    // 只在第一次绑定事件监听器，避免重复绑定
                    if(!this.eventListenersBound){
                      // 监听播放器事件
                      this.$refs.player.dp.on('error', () => {
                      console.warn('播放器错误事件触发');
                      
                      // 尝试获取视频元素的错误信息
                      const videoElement = this.$refs.player.$el?.querySelector('video');
                      if(videoElement){
                        // 立即检查 readyState，如果视频已经就绪，可能是图片加载失败，忽略错误
                        if(videoElement.readyState === 4){
                          console.log('视频已就绪（readyState=4），可能是图片加载失败，忽略错误');
                          console.log('视频网络状态:', videoElement.networkState);
                          console.log('视频就绪状态:', videoElement.readyState);
                          console.log('视频源:', videoElement.src || videoElement.currentSrc);
                          return; // 视频可以播放，忽略此错误
                        }
                        
                        // 延迟检查 error，因为 error 可能不会立即设置
                        setTimeout(() => {
                          // 再次检查 readyState，如果已经就绪，不显示错误
                          if(videoElement.readyState === 4){
                            console.log('视频已就绪，忽略错误（可能是图片加载失败）');
                            return;
                          }
                          
                          if(videoElement.error){
                            console.error('视频元素错误代码:', videoElement.error.code);
                            console.error('视频元素错误消息:', videoElement.error.message);
                            console.error('视频网络状态:', videoElement.networkState);
                            console.error('视频就绪状态:', videoElement.readyState);
                            
                            let errorMsg = '動画の読み込みに失敗しました';
                            const errorCode = videoElement.error.code;
                            if(errorCode === 1) errorMsg = '動画の読み込みが中止されました';
                            else if(errorCode === 2) errorMsg = 'ネットワークエラーが発生しました';
                            else if(errorCode === 3) errorMsg = '動画のデコードに失敗しました';
                            else if(errorCode === 4) errorMsg = '動画形式がサポートされていません';
                            
                            this.$toast(errorMsg);
                          } else if(videoElement.networkState === 3){ // NETWORK_NO_SOURCE
                            console.error('视频源未找到');
                            this.$toast('動画ソースが見つかりません');
                          } else if(videoElement.readyState === 0){ // HAVE_NOTHING
                            console.warn('视频尚未加载任何数据');
                            // 不显示错误，可能还在加载中
                          } else {
                            // 其他情况，可能是图片加载失败，不显示错误
                            console.warn('可能是图片加载失败，视频状态:', {
                              networkState: videoElement.networkState,
                              readyState: videoElement.readyState
                            });
                          }
                        }, 200);
                      }
                    });
                    
                    this.$refs.player.dp.on('canplay', () => {
                      console.log('视频可以播放');
                      // 视频可以播放时，清除之前的错误提示
                    });
                    
                    this.$refs.player.dp.on('loadeddata', () => {
                      console.log('视频数据已加载');
                    });
                    
                    this.$refs.player.dp.on('loadedmetadata', () => {
                      console.log('视频元数据已加载');
                    });
                    
                    this.$refs.player.dp.on('loadstart', () => {
                      console.log('开始加载视频');
                    });
                    
                    this.$refs.player.dp.on('waiting', () => {
                      console.log('视频缓冲中...');
                    });
                    
                    // 标记事件已绑定
                    this.eventListenersBound = true;
                    } // 结束 if(!this.eventListenersBound)
                    
                  } catch(e) {
                    console.error('更新视频源失败:', e);
                    console.error('错误堆栈:', e.stack);
                    this.$toast('動画の読み込みに失敗しました: ' + (e.message || '未知错误'));
                  }
                } else {
                  console.warn('播放器实例不存在，等待初始化...');
                  // 如果播放器还没初始化，再等待一下
                  setTimeout(() => {
                    if(this.$refs.player && this.$refs.player.dp){
                      const videoConfig = {
                        url: this.videoUrl,
                        type: this.getVideoType(this.videoUrl)
                      };
                      if(this.videoPic){
                        videoConfig.pic = this.videoPic;
                      }
                      this.$refs.player.dp.switchVideo(videoConfig);
                    } else {
                      console.error('播放器初始化超时');
                      //this.$toast('プレーヤーの初期化に失敗しました');
                    }
                  }, 1000);
                }
              }, 500);
            });
            }; // 结束 updatePlayer 函数定义
            
            // 预加载封面图片，如果加载失败（CORS 等），则不设置 pic
            if(this.videoInfo.vod_pic){
              const img = new Image();
              img.crossOrigin = 'anonymous'; // 尝试跨域加载
              img.onload = () => {
                // 图片加载成功，设置封面
                this.videoPic = this.videoInfo.vod_pic;
                updatePlayer(); // 图片加载成功后再更新播放器
              };
              img.onerror = () => {
                // 图片加载失败（可能是 CORS 问题），不设置封面，避免错误提示
                // 静默处理，不输出日志（浏览器会显示 CORS 错误，这是正常的）
                this.videoPic = ''; // 设置为空，不显示封面
                updatePlayer(); // 即使图片加载失败，也要更新播放器（不设置封面）
              };
              // 开始加载图片
              img.src = this.videoInfo.vod_pic;
            } else {
              this.videoPic = '';
              updatePlayer(); // 没有封面图片，直接更新播放器
            }
          } else {
            this.$toast('動画情報が不完全です');
            console.error('视频信息不完整:', this.videoInfo);
          }
        } else {
          this.$toast(res.msg || '获取视频信息失败');
        }
      }).catch(err => {
        console.error('获取视频信息错误:', err);
        this.$toast('获取视频信息失败');
      })

    },
	handlePlay(){
	  console.log('播放');
	  this.is_zz=true
	},
	handlePause(){
	  console.log('暂停');
	},
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'?id='+id})
        location.reload();
      }

    },
    getMoreVideoItem(){
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res=>{
          this.moreVideoInfo = res.data;
      })
    },
    getVideo() {
      this.player = videojs("my-video",  {
        height:"200px",
        preload: "auto", // 预加载
        controls: true,  // 显示播放的控件
        multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      });
      this.player.src([{
        src: this.nowPlayVideoUrl,
        type: "application/x-mpegURL" // 告诉videojs,这是一个hls流
      }]);

    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }else {
            if(this.$store.getters.getBaseInfo.isplay == 1){
              this.getVideoInfo();
              this.getMoreVideoItem()
              if(this.userInfo.money <= "0.00"){
                this.$toast(this.$t('video.plsrefisrt'));
                this.$router.push({path:'/Home'})
              }
            }else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getVideoType(url) {
      // 根据视频 URL 判断视频类型
      if (!url) return 'normal';
      if (url.includes('.m3u8')) return 'hls';
      if (url.includes('.flv')) return 'flv';
      return 'normal';
    },
  },
  mounted() {
    // vue-dplayer 会自动处理 container，不需要手动设置
    // 等待播放器初始化完成后再设置背景图片和监听事件
    this.$nextTick(() => {
      setTimeout(() => {
        if(this.videoPic){
          const bezel = document.querySelector(".dplayer-bezel");
          if(bezel){
            bezel.style.backgroundImage = 'url("'+this.videoPic+'")';
            bezel.style.backgroundRepeat = 'no-repeat';
            bezel.style.backgroundSize = 'cover';
          }
        }
        
        // 在 mounted 中也监听播放器事件，作为备用
        if(this.$refs.player && this.$refs.player.dp){
          // 监听视频元素的错误事件
          const videoElement = this.$refs.player.$el?.querySelector('video');
          if(videoElement){
            // 检查当前是否已有错误
            if(videoElement.error){
              console.error('视频元素已有错误:', {
                code: videoElement.error.code,
                message: videoElement.error.message,
                networkState: videoElement.networkState,
                readyState: videoElement.readyState
              });
            }
            
            videoElement.addEventListener('error', (e) => {
              console.warn('视频元素错误事件触发');
              console.warn('事件对象:', e);
              console.warn('目标元素:', e.target);
              
              const targetVideo = e.target;
              
              // 立即检查 readyState，如果视频已经就绪，可能是图片加载失败，忽略错误
              if(targetVideo && targetVideo.readyState === 4){
                console.log('视频已就绪（readyState=4），可能是图片加载失败，忽略错误');
                console.log('视频网络状态:', targetVideo.networkState);
                console.log('视频就绪状态:', targetVideo.readyState);
                console.log('视频源:', targetVideo.src || targetVideo.currentSrc);
                return; // 视频可以播放，忽略此错误
              }
              
              // 延迟检查 error，因为 error 可能不会立即设置
              setTimeout(() => {
                if(targetVideo && targetVideo.error){
                  console.error('视频错误代码:', targetVideo.error.code);
                  console.error('视频错误消息:', targetVideo.error.message);
                  
                  // 再次检查 readyState，如果已经就绪，不显示错误
                  if(targetVideo.readyState === 4){
                    console.log('视频已就绪，忽略错误');
                    return;
                  }
                  
                  let errorMsg = '動画の読み込みに失敗しました';
                  const errorCode = targetVideo.error.code;
                  if(errorCode === 1) errorMsg = '動画の読み込みが中止されました';
                  else if(errorCode === 2) errorMsg = 'ネットワークエラーが発生しました';
                  else if(errorCode === 3) errorMsg = '動画のデコードに失敗しました';
                  else if(errorCode === 4) errorMsg = '動画形式がサポートされていません';
                  
                  this.$toast(errorMsg);
                } else {
                  // 即使 error 对象不存在，也检查网络状态和就绪状态
                  console.warn('视频网络状态:', targetVideo?.networkState);
                  console.warn('视频就绪状态:', targetVideo?.readyState);
                  console.warn('视频源:', targetVideo?.src || targetVideo?.currentSrc);
                  
                  // 如果视频已经就绪，不显示错误
                  if(targetVideo && targetVideo.readyState === 4){
                    console.log('视频已就绪，忽略错误（可能是图片加载失败）');
                    return;
                  }
                  
                  // 根据网络状态判断错误类型
                  if(targetVideo){
                    if(targetVideo.networkState === 3){ // NETWORK_NO_SOURCE
                      this.$toast('動画ソースが見つかりません');
                    } else if(targetVideo.readyState === 0){ // HAVE_NOTHING
                      // 视频还在加载中，不显示错误
                      console.log('视频还在加载中，不显示错误');
                    } else {
                      // 其他情况，可能是图片加载失败，不显示错误
                      console.log('可能是图片加载失败，不显示错误');
                    }
                  }
                }
              }, 100);
            });
            
            videoElement.addEventListener('loadstart', () => {
              console.log('视频开始加载');
            });
            
            videoElement.addEventListener('canplay', () => {
              console.log('视频可以播放');
            });
            
            videoElement.addEventListener('stalled', () => {
              console.warn('视频加载停滞');
            });
            
            videoElement.addEventListener('suspend', () => {
              console.warn('视频加载暂停');
            });
          }
        }
      }, 500);
    });
  },
  watch: {
    // 监听 videoUrl 的变化，确保播放器能正确加载视频
    videoUrl(newUrl, oldUrl) {
      if(newUrl && newUrl !== oldUrl){
        console.log('视频 URL 变化:', newUrl);
        // 如果播放器已初始化且有新的视频 URL，更新视频源
        this.$nextTick(() => {
          setTimeout(() => {
            if(this.$refs.player && this.$refs.player.dp){
              try {
                console.log('切换视频源:', newUrl);
                const videoConfig = {
                  url: newUrl,
                  type: this.getVideoType(newUrl)
                };
                if(this.videoPic){
                  videoConfig.pic = this.videoPic;
                }
                this.$refs.player.dp.switchVideo(videoConfig);
              } catch(e) {
                console.error('切换视频源失败:', e);
                this.$toast('動画の切り替えに失敗しました');
              }
            }
          }, 500);
        });
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  },
  destroyed () {
    // 安全地销毁播放器
    if(this.player && typeof this.player.dispose === 'function'){
      try {
        this.player.dispose();
      } catch(e) {
        console.error('销毁播放器失败:', e);
      }
    }
    // 如果使用 $refs.player
    if(this.$refs.player && this.$refs.player.dp){
      try {
        this.$refs.player.dp.destroy();
      } catch(e) {
        console.error('销毁播放器失败:', e);
      }
    }
  }
};
</script>

<style  scoped>
.van-nav-bar {
    z-index: 999;
    background: url(/img/header.svg) no-repeat 50%/100%;
	line-height: 2.2rem;
}

.van-nav-bar {
	position: relative;
    z-index: 999;
	height:3rem ;
	line-height: 3rem;
    background: url(/img/header.svg) no-repeat 50%/100%
}
.van-nav-bar .van-icon,.van-nav-bar__title {
    color: #fff
}
.dplayer-bezel .dplayer-bezel-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -3.467vw 0 0 -3.467vw;
    height: 16.933vw;
    width: 16.933vw;
    padding: 1.6vw;
    box-sizing: border-box;
    background: rgba(0,0,0,.5);
    border-radius: 50%;
    opacity: 0;
    pointer-events: none;
}

:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}
.hot {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap
}

.hot li {
    width: calc(50% - .33333rem);
    border-radius: .33333rem;
    overflow: hidden;
    margin-top: .66667rem;
    height: 6.66667rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center
}

.hot li img {
    height: 100%;
	width: 100%;
}

.hot li>div {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,.4);
    padding: .33333rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.hot li>div span {
    color: #fff;
    font-size: .8rem;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 .33333rem
}

:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}

.move {
    width: 100%;
    min-height: 100%;
    background: #f0f0f0
}

.move .van-popup--top {
    top: 0;
    bottom: 0;
    margin: auto;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center
}

.move .van-popup--top .box {
    width: 90%;
    height: 200px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden
}

.move .van-popup--top .box .title {
    background: linear-gradient(30deg,#7d76ef,#d63f8c);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 4% 5%
}

.move .van-popup--top .box .title p {
    font-size: 16px
}

.move .van-popup--top .box .title i {
    color: #fff
}

.move .van-popup--top .box .content h1 {
    font-size: 18px;
    padding: 30px 0
}

.move .van-popup--top .box .content a {
    background: linear-gradient(90deg,#f560cd,#4f2b8a);
    color: #fff;
    padding: 10px 20px;
    border-radius: 90px;
    font-size: 12px
}

.move .van-popup--top .box .content p {
    padding: 20px 0
}

.move .van-popup--top .box .content p span {
    color: red
}

.move .d-player-video-main {
    width: 96%!important;
    height: auto!important
}

.move .d-player-wrap {
    height: auto
}

.video-loading {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
}

.move>.title {
    background: #fff;
    width: 100%;
    padding: .66667rem 3%;
    text-align: left
}

.move>.title> {
    padding: 0 0
}

.move>.title p {
    font-weight: 600;
    color: #3e2186;
    font-size: .93333rem;
    margin-bottom: .5rem
}

.move>.title span {
    color: #aa2ddc;
    font-size: .8rem;
    background: #f2f2f5;
    padding: .33333rem .6rem;
    border-radius: .33333rem
}

.move .item {
    width: 100%;
    padding: .66667rem
}

.move .item>.title {
    display: flex;
    justify-content: space-between;
    align-items: center
}

.move .item>.title span {
    font-weight: 600;
    display: flex;
	font-size: 1rem;
    justify-content: flex-start;
    align-items: center;
    color: #4b358b
}

.move .item>.title span i {
    margin-right: .4rem
}

.move .item>.title span i img {
    width: 1.13333rem
}

.move .item>.title a {
    color: #979799
}

.poster {
    height: 13.33333rem;
    background: #000;
    position: relative
}

.poster>div,.poster {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center
}

.poster>div {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.8)
}

.poster>div .van-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
}

.poster img {
    height: 100%
}

</style>